import { Version } from '@angular/core';

export const VERSION = new Version('7.4.1');
